const  vi =  {
 translation: {
  "account": "Tài khoản",
  "auth_confirm_read": "Tôi đã đọc và hiểu",
  "auth_terms_conditions": "Điều khoản & Điều kiện",
  "auto_input_password": "Nhập mật khẩu",
  "auto_input_username": "Nhập tên đăng nhập",
  "auto_password": "Mật khẩu",
  "auto_username": "Tên đăng nhập",
  "back_home": "Quay lại trang chủ",
  "cancel_password": "Hủy bỏ",
  "change_password": "Đổi mật khẩu",
  "confirm_new_password": "Xác nhận mật khẩu mới",
  "coppy_link_error": "Sao chép liên kết thất bại",
  "coppy_link_success": "Sao chép liên kết thành công",
  "current_password": "Mật khẩu hiện tại",
  "download_file_error": "Tải xuống thất bại",
  "edit_profile_label_cancle": "Huỷ",
  "edit_profile_label_confirm": "Xác nhận",
  "edit_profile_success": "Lưu thông tin thành công",
  "edit_profile_text_warning_description": "Bạn có chắc chắn muốn hủy bỏ các thay đổi ?",
  "email": "Email",
  "error_500": "Hệ thống đang quá tải, Quý khách vui lòng thử lại sau",
  "error_backhome": "Quay lại trang chủ",
  "error_confirm_new_password": "Không giống mật khẩu mới",
  "error_new_password": "Mật khẩu mới không thể giống mật khẩu hiện tại",
  "error_page_note_found": "Không tìm thấy trang",
  "error_password": "Mật khẩu hiện tại chưa đúng",
  "fan_test_key": "vi test",
  "footer_title": "© Bản quyền thuộc về",
  "forgot_password": "Quên mật khẩu",
  "forgot_password_change_password_success": "Đổi mật khẩu thành công",
  "forgot_password_email_verified_account": "Email chưa đăng ký tài khoản",
  "forgot_password_input_placeholder": "Nhập mật khẩu mới",
  "forgot_password_reset_password": "Đặt lại mật khẩu",
  "forgot_password_success_title": "Yayy ! Đổi mật khẩu thành công",
  "forgot_password_title": "Bạn điền chính xác email đã đăng ký để lấy lại mật khẩu nhé 😥",
  "handle_redirect": "Redirect",
  "input_confirm_new_password": "Nhập lại mật khẩu mới",
  "input_current_password": "Nhập mật khẩu hiện tại",
  "input_new_password": "Nhập mật khẩu mới",
  "login": "Đăng nhập",
  "login_error_email_exist": "Email chưa đăng ký tài khoản",
  "login_error_email_format": "Email chưa đúng định dạng.",
  "login_error_email_required": "Vui lòng nhập vào email của bạn",
  "login_error_limit_fail": "Bạn đã nhập sai mật khẩu quá số lần quy định. Vui lòng thử lại sau",
  "login_error_password": "Sai mật khẩu",
  "login_error_phone_exist": "Số điện thoại chưa đăng ký",
  "login_error_phone_format": "Số điện thoại chưa đúng định dạng.",
  "login_forget_password": "Bạn quên mật khẩu?",
  "login_now": "Đăng nhập ngay",
  "login_page_close": "Đóng",
  "login_page_content": "Nền tảng Passio cho Fan",
  "login_page_copy_right": "© Passio -",
  "login_page_password_placeholder": "Nhập mật khẩu của bạn",
  "login_page_placeholder": "Nhập email của bạn",
  "login_page_question": "Bạn chưa có tài khoản?",
  "login_page_register": "Đăng ký ngay",
  "login_page_title": "Đăng nhập",
  "login_password_placeholder": "Nhập mật khẩu",
  "login_phone_placeholder": "Nhập số điện thoại",
  "login_reinstall_password": "Cài đặt lại mật khẩu",
  "login_success": "Đăng nhập thành công",
  "login_success_title": "Yayy ! Đăng nhập thành công",
  "new_password": "Mật khẩu mới",
  "next": "Tiếp theo",
  "otp_accuracy": "Xác thực",
  "otp_continute_without_verification": "Tiếp tục mà không cần xác thực",
  "otp_email_title": "Mã xác thực đã được gửi đến email",
  "otp_error_invalid_email": "Email chưa đúng định dạng.",
  "otp_error_limit_send_otp": "Số lần nhập quá giới hạn cho phép, vui lòng gửi lại OTP mới",
  "otp_error_limit_time": "Bạn đã thao tác quá số lần cho phép. Xin quay lại sau {{time}} để tiếp tục.",
  "otp_error_otp_not_found": "Mã OTP không tồn tại.",
  "otp_error_timeout": "OTP đã hết hạn, vui lòng chọn gửi lại OTP.",
  "otp_resend": "Gửi lại OTP",
  "otp_screen_please_wait_after": "giây để gửi lại.",
  "otp_screen_please_wait_before": "Vui lòng chờ",
  "password": "Mật khẩu",
  "password_accept_condition": "Sau khi bấm nút Đăng ký, bạn đã chấp nhận",
  "password_cancle": "Hủy",
  "password_change": "Thay đổi mật khẩu",
  "password_confirm": "Xác nhận",
  "password_error_digit": "Tối thiểu 1 chữ số",
  "password_error_min_length": "Độ dài hơn 8 kí tự",
  "password_error_timeout": "Đã quá thời gian cài đặt mật khẩu, bạn vui lòng thao tác lại.",
  "password_error_uppercase": "Tối thiểu 1 chữ hoa",
  "password_input_placeholder": "E.g: Matkhau112359",
  "password_max": "Vui lòng nhập tối đa {{max}} ký tự",
  "password_min": "Vui lòng nhập tối thiểu {{min}} ký tự",
  "password_required": "Vui lòng nhập thông tin này",
  "password_setup": "Cài đặt mật khẩu",
  "password_term_condition": "Điều khoản & Điều kiện",
  "phone": "Số điện thoại",
  "register": "Đăng ký",
  "register_email_placeholder": "Nhập vào email của bạn",
  "register_erro_min_length": "Độ dài tối thiểu {{min}} ký tự",
  "register_error_email_error": "Email chưa đúng định dạng.",
  "register_error_email_existed": "Email đã đăng kí tài khoản",
  "register_error_email_invalid_format": "Email chưa đúng định dạng.",
  "register_error_limit_send": "Bạn đã thao tác quá số lần cho phép. Xin quay lại sau {{time}} để tiếp tục.",
  "register_error_max_length": "Chỉ cho phép tối đa {{max}} ký tự",
  "register_error_username_existed": "Tên đăng nhập đã tồn tại",
  "register_error_username_matches": "Chỉ cho phép các ký tự từ a-z và 0-9",
  "register_otp": "Xác thực OTP",
  "register_page_description": "Tạo tài khoản của bạn và bắt đầu hành trình tại Passio",
  "register_page_title": "Đăng ký tài khoản",
  "register_phone_placeholder": "Nhập số điện thoại",
  "register_success": "Đăng ký thành công",
  "register_success_description": "Chúc mừng bạn đã đăng ký tài khoản thành công. Chào mừng bạn đến nền tảng Passio",
  "register_success_title": "Yayy ! Đăng ký thành công",
  "register_verified_email": "Email đã đăng ký tài khoản",
  "save_password": "Lưu",
  "save_password_false": "Mật khẩu chưa được thay đổi",
  "save_password_success": "Bạn đã đổi mật khẩu thành công",
  "shoutout_back": "Quay lại",
  "shoutout_content": "Nội dung",
  "shoutout_create_request": "Tạo yêu cầu",
  "shoutout_created_at": "Thời gian tạo",
  "shoutout_decline": "Từ chối",
  "shoutout_expired_time": "Thời gian hết hạn",
  "shoutout_feed_back": "Phản hồi từ {{name}}",
  "shoutout_new": "Mới",
  "shoutout_occasion_advice": "Lời khuyên",
  "shoutout_occasion_birthday": "Sinh nhật",
  "shoutout_occasion_mobilize": "Động viên",
  "shoutout_occasion_other": "Các dịp khác",
  "shoutout_occasion_question": "Câu hỏi",
  "shoutout_occasion_special": "Dịp đặc biệt",
  "shoutout_pronoun_aunt": "Cô",
  "shoutout_pronoun_big_uncle": "Bác",
  "shoutout_pronoun_bro": "Em",
  "shoutout_pronoun_friend": "Bạn",
  "shoutout_pronoun_grandfather": "Ông",
  "shoutout_pronoun_grandmother": "Bà",
  "shoutout_pronoun_he": "Anh",
  "shoutout_pronoun_she": "Chị",
  "shoutout_pronoun_uncle": "Chú",
  "shoutout_reject_reason": "Lý do từ chối",
  "shoutout_replied": "Đã thực hiện",
  "shoutout_request_code": "Mã yêu cầu",
  "shoutout_request_detail": "Chi tiết yêu cầu",
  "shoutout_request_noti": "Yêu cầu đang được thực hiện",
  "shoutout_request_status": "Trạng thái yêu cầu",
  "shoutout_share": "Chia sẻ",
  "shoutout_to": "Đến",
  "spl_add_item_to_live": "Thêm sản phẩm vào LIVE",
  "spl_add_link": "Tìm sản phẩm",
  "spl_add_link_content_success": "Sản phẩm của bạn đã được thêm LÊN ĐẦU GIỎ LIVE. PHẢI BẤM vào link thì MỚI VÀO ĐÚNG livestream chứa sản phẩm của bạn !",
  "spl_add_link_error_content": "Hiện tại không thể thêm sản phẩm vào live",
  "spl_add_link_error_title": "Thêm sản phẩm vào giỏ Live Lỗi",
  "spl_add_link_title": "Thêm link",
  "spl_add_link_title_success": "Thêm sản phẩm vào giỏ Live thành công",
  "spl_back": "Quay lại",
  "spl_cannot_add_item_to_shopee_live_session": "Không thể thêm sản phẩm vào Shopee live",
  "spl_cannot_find_seller": "Không tìm thấy thông tin người live",
  "spl_close": "Đóng",
  "spl_cps_token_is_empty": "Thông tin không hợp lệ",
  "spl_go_to_live_label": "Đến live ngay",
  "spl_guide_text": "Cách thêm sản phẩm bất kì vào live",
  "spl_invalid_url": "Link không hợp lệ",
  "spl_item_index": "Số thứ tự sản phẩm trong giỏ live là",
  "spl_item_link_click_here": "Bấm vào link này",
  "spl_link_accept": "Link không hợp lệ",
  "spl_link_is_not_empty": "Link Không được để trống",
  "spl_ok": "ok",
  "spl_paste_link_here": "Dán link ở đây",
  "spl_position_in_live_label": "STT trên LIVE",
  "spl_product_already_exists_in_live": "Sản phẩm đã tồn tại trong live",
  "spl_product_empty_searching_label": "Không tìm thấy sản phẩm nào",
  "spl_product_invalid": "Vui lòng nhập đúng link sản phẩm Shopee",
  "spl_related_product_list_header_label": "Săn sale Shopee",
  "spl_related_product_list_title": "Sản phẩm tương tự có trong live",
  "spl_shopee_session_id_is_empty": "Chưa sẵn sàng live",
  "spl_title": "Shopee live",
  "spl_view_related_product_list_label": "Xem sản phẩm tương tự",
  "ss_add_voucher_successs": "Áp dụng mã thành công",
  "ss_back_donation_detail": "Thanh toán",
  "ss_back_to_homepage_creator": "Về trang cá nhân Creator",
  "ss_back_tod_detail": "Thanh toán",
  "ss_brand_gift_cashback": "Cashback",
  "ss_brand_gift_deal_name": "Tên deal",
  "ss_brand_gift_deal_price": "Giá deal",
  "ss_brand_gift_does_have_gift": "Có",
  "ss_brand_gift_does_not_have_gift": "Không",
  "ss_brand_gift_has_gift": "Quà tặng",
  "ss_brand_gift_heart": "Tim tích luỹ",
  "ss_brand_gift_heart_cashback_heart": "Đã hoàn",
  "ss_brand_gift_heart_left_heart": "Còn lại",
  "ss_brand_gift_heart_link_text": "Xem tim tích luỹ tại đây",
  "ss_brand_gift_heart_total_heart": "Tổng tim tích luỹ",
  "ss_brand_gift_order_amount": "Giá tiền sản phẩm",
  "ss_brand_gift_order_support_info": "Bạn cần giúp đỡ",
  "ss_brand_gift_payment_history": "Brand Gift",
  "ss_brand_gift_showing_after_heart_text": "đạt được",
  "ss_brand_gift_showing_before_heart_text": "Số",
  "ss_brand_gift_support_method": "Kênh hỗ trợ",
  "ss_brand_gift_title_type_ecommerce": "Online",
  "ss_brand_gift_title_type_o2o": "Offline",
  "ss_brand_gift_voucher": "Voucher sử dụng",
  "ss_brand_rating_KOL_domain": "Trang KOL",
  "ss_brand_rating_back": "Hủy bỏ",
  "ss_brand_rating_back_to_payment_history": "Lịch sử mua hàng",
  "ss_brand_rating_button_update_payment_info": "Cập nhật ngay",
  "ss_brand_rating_cancel_order": "Admin hủy deal đơn hàng",
  "ss_brand_rating_cancel_order_sub_step_1": "Bạn đã cập nhật thông tin đơn hàng sai. Admin đã từ chối lượt mua deal hoàn tiền của bạn.",
  "ss_brand_rating_cancel_order_sub_step_2": "Bạn đã cập nhật thông tin đánh giá sai 2 lần. Admin từ chối lượt mua deal hoàn tiền của bạn.",
  "ss_brand_rating_cashback": "Hoàn",
  "ss_brand_rating_content_1": "1. Ảnh đơn hàng yêu cầu các thông tin:",
  "ss_brand_rating_content_2": "2. Mã đơn hàng là mã được sàn TMDT cung cấp cho người mua sau khi tiến hành đặt hàng thành công.",
  "ss_brand_rating_content_3": "3. Email là thông tin bạn đã cung cấp để đăng ký nhận deal thành công.",
  "ss_brand_rating_content_child_1": "Đánh giá 5 sao (bắt buộc)",
  "ss_brand_rating_content_child_2": "Nội dung đánh giá tốt về sản phẩm (bắt buộc)",
  "ss_brand_rating_content_child_3": "Có ảnh/video về sản phẩm (không bắt buộc)",
  "ss_brand_rating_cover_image_helper": "Hỗ trợ: JPG, JPEG, GIF, PNG, BMP, WebP, tối đa 4MB",
  "ss_brand_rating_details_order": "Chi tiết đơn hàng",
  "ss_brand_rating_discount": "Giảm",
  "ss_brand_rating_edit": "Chỉnh sửa",
  "ss_brand_rating_end_time": "Hạn Deal",
  "ss_brand_rating_error_404": "Bạn không được phép truy cập vào link này",
  "ss_brand_rating_fill_code": "Mã đơn hàng",
  "ss_brand_rating_fill_email": "Email",
  "ss_brand_rating_get_cashback_from_passio": "Nhận hoàn tiền từ Passio",
  "ss_brand_rating_get_cashback_from_passio_sub": "Thời gian hoàn tiền tối đa trong 7 ngày. Trong trường hợp chưa cung cấp thông tin thanh toán, bạn cần cập nhật để nhận hoàn tiền.",
  "ss_brand_rating_order_code": "Mã đơn hàng",
  "ss_brand_rating_order_content_child_1": "Tên sản phẩm trùng với tên sản phẩm của deal",
  "ss_brand_rating_order_content_child_2": "Mã đơn hàng",
  "ss_brand_rating_order_content_child_3": "Khoảng thông báo xác nhận chờ thanh toán (COD) và chờ vận chuyển (đã thanh toán)",
  "ss_brand_rating_order_heart": "Tim tích lũy",
  "ss_brand_rating_placeholder_code": "Nhập mã đơn hàng",
  "ss_brand_rating_register_deal_time": "Thời gian đăng ký Deal",
  "ss_brand_rating_save": "Lưu",
  "ss_brand_rating_showing_after_heart_text": "Danh sách sản phẩm",
  "ss_brand_rating_status": "Trạng thái",
  "ss_brand_rating_status_failed": "Từ chối",
  "ss_brand_rating_status_new": "Đang chờ",
  "ss_brand_rating_status_success": "Thành công",
  "ss_brand_rating_step_0_description": "Đơn hàng đăng ký từ hệ thống",
  "ss_brand_rating_step_0_title": "Đăng ký nhận Deal",
  "ss_brand_rating_step_1_description": "Upload ảnh đơn hàng hợp lệ và cập nhật các thông tin yêu cầu.",
  "ss_brand_rating_step_1_description_fail": "Bạn đã cập nhật thông tin đơn hàng sai. Admin đã từ chối lượt mua deal hoàn tiền của bạn.",
  "ss_brand_rating_step_1_fail": "Admin đã từ chối thông tin ảnh của bạn",
  "ss_brand_rating_step_1_pending": "Đơn hàng đang chờ admin xét duyệt",
  "ss_brand_rating_step_1_title": "Cập nhật đơn hàng",
  "ss_brand_rating_step_2_description": "Upload ảnh đánh giá của bạn về sản phẩm mà bạn đã nhận",
  "ss_brand_rating_step_2_fail": "Admin đã từ chối thông tin ảnh của bạn",
  "ss_brand_rating_step_2_pending_1": "Đơn hàng đang chờ admin xét duyệt",
  "ss_brand_rating_step_2_pending_2": "Bạn đã cập nhật sai thông tin. Chỉ còn 1 lần để bạn cập nhật lại.",
  "ss_brand_rating_step_2_title": "Đánh giá đơn hàng 5*",
  "ss_brand_rating_step_3_description": "Thời gian hoàn tiền tối đa trong 7 ngày. Trường hợp bạn chưa cung cấp thông tin thanh toán, vui lòng cập nhật để nhận hoàn tiền.",
  "ss_brand_rating_step_3_description_clamp_heath": "Số tiền được hoàn tương đương với",
  "ss_brand_rating_step_3_description_done": "Thời gian hoàn tiền tối đa trong 7 ngày.",
  "ss_brand_rating_step_3_description_heart": "{{heart}}❤.",
  "ss_brand_rating_step_3_title": "Nhận hoàn tiền từ Passio",
  "ss_brand_rating_text_cash_back": "Hoàn tiền",
  "ss_brand_rating_text_percent": "Hoàn",
  "ss_brand_rating_title": "Tải ảnh đơn hàng",
  "ss_brand_rating_title_detail_order": "Chi tiết đơn hàng",
  "ss_brand_rating_title_hepler": "Lưu ý:",
  "ss_brand_rating_title_upload_rating": "Tải ảnh đánh giá đơn hàng",
  "ss_brand_rating_toast_success": "Bạn đã gửi thông tin thành công",
  "ss_brand_rating_update_order": "Cập nhật đơn đặt hàng",
  "ss_brand_rating_update_order_sub": "Bạn cần cập nhật thông tin mua đơn hàng thành công.",
  "ss_brand_rating_update_payment": "Câp nhật thông tin thanh toán",
  "ss_brand_rating_update_payment_info": "Cập nhật thanh toán",
  "ss_brand_rating_update_rating_sub": "Bạn cần cập nhật thông tin đánh giá 5 sao về sản phẩm",
  "ss_brand_rating_upload_cover_image": "Ảnh đơn hàng",
  "ss_brand_rating_upload_file_format_invalid_content": "Ảnh không đúng định dạng. Vui lòng chọn một trong các định dạng: JPG, JPEG, GIF, PNG, BMP, WebP",
  "ss_brand_rating_upload_file_size_invalid_content": "Vui lòng chọn file có dung lượng tối đa 10MB",
  "ss_brand_rating_upload_order": "Tải ảnh đơn hàng",
  "ss_brand_rating_upload_order_again": "Tải lại ảnh đơn hàng",
  "ss_brand_rating_upload_rating": "Cập nhật thông tin đánh giá 5 sao",
  "ss_brand_rating_upload_rating_again": "Cập nhật lại thông tin đánh giá 5 sao",
  "ss_brand_rating_upload_success_modal_order": "Chúc mừng bạn đã tải ảnh đơn hàng thành công! Bạn có thể theo dõi thêm lịch sử và trạng thái mua hàng.",
  "ss_brand_rating_upload_success_modal_rating": "Để nhận được hoàn tiền của chúng tôi, bạn cần cập nhật thông tin thanh toán",
  "ss_brand_rating_validate_code": "Trường dữ liệu không được để trống",
  "ss_brand_rating_validate_upload": "Trường dữ liệu không được để trống",
  "ss_call_hotline": "Gọi hotline",
  "ss_checkout_disclamer_content_popup_tiktok": "Để quá trình thanh toán thuận lợi hơn vui lòng chọn \"Mở trong trình duyệt\"",
  "ss_checkout_disclamer_popup_tiktok": "Khuyến cáo",
  "ss_checkout_email_after": "Phần đứng trước '@' không được chứa biểu tượng ' '",
  "ss_checkout_email_before": "Phần đứng sau '@' không được chứa biểu tượng ' '",
  "ss_checkout_email_duplicate": "Phần đứng sau '@' không được chứa biểu tượng '@'",
  "ss_checkout_email_must": "Vui lòng bao gồm '@' trong mail.",
  "ss_checkout_phone_require": "Bạn nhập Số điện thoại nhé",
  "ss_checkout_select_voucher": "Bạn đã có mã giảm giá?",
  "ss_checkout_voucher_empty_text": "Chưa có mã giảm giá",
  "ss_checkout_voucher_empty_text_suggest": "Để thêm mã giảm giá, vui lòng nhập & ấn nhấn nút “Áp dụng” ở phía trên",
  "ss_convert_heart_amount_error": "Chưa đủ số tim tích luỹ",
  "ss_convert_heart_button": "Quy đổi tim",
  "ss_convert_heart_choose_phone_scratch_card": "Chọn mệnh giá thẻ cào",
  "ss_convert_heart_convert_btn_cancle": "Hủy bỏ",
  "ss_convert_heart_convert_btn_confirm": "Xác nhận",
  "ss_convert_heart_error_phone_format": "Bạn nhập đúng số điện thoại nhé",
  "ss_convert_heart_error_phone_required": "Vui lòng nhập vào số điện thoại",
  "ss_convert_heart_info_1_hearts_convert": "1 tim",
  "ss_convert_heart_instruct_phone_number": "Vui lòng nhập chính xác số điện thoại bạn muốn nhận tiền",
  "ss_convert_heart_number_convert": "Số tim quy đổi",
  "ss_convert_heart_phone_number_input": "Số điện thoại",
  "ss_convert_heart_placeholder_phone_number": "Nhập vào số điện thoại",
  "ss_convert_heart_request_existed": "Đang có yêu cầu quy đổi tim chờ duyệt. Vui lòng quay lại sau",
  "ss_convert_heart_send_request_convert": "Gửi yêu cầu",
  "ss_convert_heart_success": "Gửi yêu cầu quy đổi tim thành công. Vui lòng chờ từ 3-5 ngày.",
  "ss_convert_heart_title_popup": "Tạo yêu cầu quy đổi tim",
  "ss_convert_heart_verify_account_btn_cancel": "Huỷ",
  "ss_convert_heart_verify_account_btn_confirm": "Xác thực tài khoản",
  "ss_convert_heart_warning_account_des_1": "Vui lòng truy cập",
  "ss_convert_heart_warning_account_des_2": "hồ sơ cá nhân",
  "ss_convert_heart_warning_account_des_3": "để xác thực tài khoản",
  "ss_convert_heart_warning_convert_des": "Bạn có chắc chắn muốn quy đổi tim cho số điện thoại",
  "ss_convert_heart_warning_convert_title": "Xác nhận ?",
  "ss_copied": "Copied",
  "ss_copy_failed": "Sao chép không thành công",
  "ss_create_account_donation": "Tạo tài khoản",
  "ss_creator": "Creator",
  "ss_creator_tod": "Creator",
  "ss_decline_status_tod": "Từ chối",
  "ss_details": "Thông tin chi tiết",
  "ss_disable_referral_button_share": "Chương trình kết thúc",
  "ss_discount_ammount": "Giảm giá",
  "ss_donate_success": "Lì xì thành công",
  "ss_donation_btn_checkout": "Thanh toán",
  "ss_donation_checkout_email_notification": "👉 Sản phẩm của bạn sẽ được gửi qua email, bạn nhập chính xác nhé.",
  "ss_donation_checkout_email_title": "Email",
  "ss_donation_checkout_phone_placeholder": "09xxxxxxxx",
  "ss_donation_checkout_phone_title": "Số điện thoại",
  "ss_donation_checkout_private_message_title": "Đặt lời nhắn ở chế độ riêng tư",
  "ss_donation_checkout_user_message_title": "Lời nhắn cho Creator",
  "ss_donation_code": "Mã ủng hộ",
  "ss_donation_confirm_leave_order": "Cài đặt của bạn chưa được lưu. Bạn có muốn rời khỏi đây không?",
  "ss_donation_message_from_user": "Lời nhắn từ bạn",
  "ss_donation_name_kol": "Ủng hộ",
  "ss_donation_pending_title": "Giao dịch đang được xử lý",
  "ss_donation_time": "Thời gian ủng hộ",
  "ss_donation_user_message_placeholder": "Bạn thử nhắn gì đó với người sáng tạo nhé 🤑",
  "ss_duplicate_email": "Email đã đăng kí tài khoản",
  "ss_duplicate_username": "Tên đăng nhập đã tồn tại",
  "ss_edit_profile": "Chỉnh sửa hồ sơ",
  "ss_email": "Email",
  "ss_enter_course": "Tham gia ngay",
  "ss_error_not_enough_money": "Có lỗi xảy ra, hiện tại không thể thanh toán",
  "ss_expired_voucher": "Rất tiếc! Mã giảm giá này đã hết hạn sử dụng",
  "ss_fail_name_kol": "thất bại",
  "ss_fan_add_voucher_button": "Áp dụng",
  "ss_fan_brand_gift_title": "ƯU ĐÃI THƯƠNG HIỆU",
  "ss_fan_brand_rating_title": "GIAN HÀNG BÍ MẬT",
  "ss_fan_checkout_total_price": "Tổng tiền",
  "ss_fan_date_picker_text_custom_range": "Tùy chỉnh khoảng thời gian",
  "ss_fan_date_picker_text_last_n_day": "{{n}} ngày gần nhất",
  "ss_fan_date_picker_text_last_week": "Tuần trước",
  "ss_fan_date_picker_text_this_month": "Tháng này",
  "ss_fan_date_picker_text_this_week": "Tuần này",
  "ss_fan_date_picker_text_today": "Hôm nay",
  "ss_fan_date_picker_text_yesterday": "Hôm qua",
  "ss_fan_empty_heart": "Không có đơn hàng được hoàn tim",
  "ss_fan_exclusive_passio_badge": "Độc quyền",
  "ss_fan_input_voucher_placeholder": "Nhập mã",
  "ss_fan_my_title": "Mã giảm giá của tôi",
  "ss_fan_no_photo_has_been_selected": "Chưa có ảnh nào được chọn",
  "ss_fan_profile_help_channel_fb": "Kênh hỗ trợ",
  "ss_fan_profile_help_email": "Email",
  "ss_fan_profile_help_popup_title": "Trợ giúp",
  "ss_fan_profile_info": "Thông tin cá nhân",
  "ss_fan_upload_button_label": "Tải ảnh lên",
  "ss_fan_voucher_label_date": "Hết hạn:",
  "ss_fe_fan_edit_profile_cancel_button": "Hủy",
  "ss_fe_fan_edit_profile_confirm_button": "Xong",
  "ss_fe_fan_edit_profile_label_confirm": "Xác nhận",
  "ss_fe_fan_edit_profile_personal_tax_code_had": "Đã có",
  "ss_fe_fan_edit_profile_personal_tax_code_had_not": "Chưa có",
  "ss_fe_fan_edit_profile_title_calender": "Chọn ngày",
  "ss_fe_fan_edit_profile_validate_date_identification": "Ngày cấp không hợp lệ",
  "ss_fe_fan_edit_profile_validate_invalid": "Thông tin chưa đúng định dạng.",
  "ss_fe_fan_edit_profile_validate_max_length": "Vui lòng nhập tối đa {{num}} kí tự",
  "ss_fe_fan_edit_profile_validate_number_0_to_9": "Vui lòng chỉ nhập chữ số (0-9)",
  "ss_fe_fan_edit_profile_validate_required": "Trường dữ liệu không được để trống.",
  "ss_fe_fan_edit_profile_validate_required_file": "Trường dữ liệu không được để trống 1 trong 2",
  "ss_fe_fan_profile_address_user": "Địa chỉ",
  "ss_fe_fan_profile_address_user_placeholder": "Nhập địa chỉ của bạn",
  "ss_fe_fan_profile_country_alias": "Quốc gia",
  "ss_fe_fan_profile_country_chosen": "Chọn quốc gia",
  "ss_fe_fan_profile_country_helper": "Chọn quốc gia tương ứng với tài khoản thanh toán của bạn",
  "ss_fe_fan_profile_momo_account": "Tài khoản Momo",
  "ss_fe_fan_profile_momo_account_helper": "Trường này phải trùng với tên tài khoản nhận tiền và không được thay đổi",
  "ss_fe_fan_profile_momo_account_name": "Tên chủ tài khoản",
  "ss_fe_fan_profile_momo_account_name_placeholder": "Nhập tên chủ tài khoản",
  "ss_fe_fan_profile_momo_phone_placeholder": "Nhập tài khoản MoMo",
  "ss_fe_fan_profile_payment_account_name": "Tên chủ thẻ",
  "ss_fe_fan_profile_payment_account_number": "Số tài khoản",
  "ss_fe_fan_profile_payment_account_number_placeholder": "Nhập số tài khoản",
  "ss_fe_fan_profile_payment_alias": "Thanh toán",
  "ss_fe_fan_profile_payment_bank_account": "Tài khoản ngân hàng",
  "ss_fe_fan_profile_payment_bank_alias": "Ngân hàng thụ hưởng",
  "ss_fe_fan_profile_payment_bank_name_placeholder": "Nhập tên ngân hàng thụ hưởng của bạn",
  "ss_fe_fan_profile_payment_branch": "Chi nhánh",
  "ss_fe_fan_profile_payment_branch_new_placeholder": "Nhập chi nhánh ngân hàng của bạn",
  "ss_fe_fan_profile_payment_branch_placeholder": "Nhập tên ngân hàng của bạn",
  "ss_fe_fan_profile_payment_date_identification": "Ngày phát hành KTP",
  "ss_fe_fan_profile_payment_file_back": "Mặt sau",
  "ss_fe_fan_profile_payment_file_front": "Mặt trước",
  "ss_fe_fan_profile_payment_file_helper": "Đính kèm 2 ảnh KTP của bạn: Mặt trước, mặt sau. Yêu cầu tải lên hình ảnh rõ ràng, chi tiết.",
  "ss_fe_fan_profile_payment_identification": "Số KTP",
  "ss_fe_fan_profile_payment_identification_placeholder": "Nhập số KTP",
  "ss_fe_fan_profile_payment_image_identification": "Ảnh KTP(Passport)",
  "ss_fe_fan_profile_payment_personal_tax": "Mã số thuế",
  "ss_fe_fan_profile_payment_personal_tax_placeholder": "Nhập mã số thuế cá nhân",
  "ss_fe_fan_profile_tl_alias": "Thái Lan",
  "ss_fe_fan_profile_vn_alias": "Việt Nam",
  "ss_fe_fan_voucher_title": "Mã giảm giá",
  "ss_for_you": "gửi tới bạn 🤗",
  "ss_hotline": "Hotline",
  "ss_label_tod_link_success": "Thông tin đơn Truth or Dare đã được gửi tới email",
  "ss_lable_back_success_donation": "Chi tiết ủng hộ",
  "ss_lable_back_success_tod": "Chi tiết thanh toán",
  "ss_lable_link_success": "Thông tin ủng hộ đã được gửi tới email",
  "ss_logout": "Đăng xuất",
  "ss_modal_timeout_register_now": "Đăng ký ngay",
  "ss_next_register": "Tạo tài khoản",
  "ss_no": "Không",
  "ss_order_code": "Mã đơn hàng",
  "ss_order_date": "Thời gian đặt hàng",
  "ss_order_detail": "Chi tiết đơn hàng",
  "ss_order_fail": "Đặt hàng thất bại",
  "ss_order_history_accepted": "Đang chờ",
  "ss_order_history_empty_text": "Bạn hiện tại chưa có bất kỳ sản phẩm nào",
  "ss_order_history_empty_text_suggest": "Hãy mua sản phẩm ủng hộ cho KOL nhé",
  "ss_order_history_new": "Mới",
  "ss_order_history_refund": "Hoàn trả",
  "ss_order_history_replied": "Đã thực hiện",
  "ss_order_history_reply_text": "Trả lời",
  "ss_order_message_from_kol": "Phản hồi từ KOL",
  "ss_order_message_from_user": "Lời nhắn từ bạn",
  "ss_order_momo_wallet": "MoMo E-Wallet",
  "ss_order_note_lucky_sent_email": "Thông tin lì xì đã được gửi tới email",
  "ss_order_note_sent_email": "Đơn hàng đã được gửi tới email",
  "ss_order_pending": "Giao dịch đang được xử lý",
  "ss_order_pending_title": "Giao dịch đang được xử lý",
  "ss_order_success": "Đặt hàng thành công",
  "ss_order_tod_date": "Thời gian thanh toán",
  "ss_order_tod_message_from_kol": "Phản hồi từ Creator",
  "ss_payment_GBPRIMEPAY_CREDIT_CARD": "Credit Cards",
  "ss_payment_GBPRIMEPAY_QRCASH": "PromptPay",
  "ss_payment_GBPRIMEPAY_RABBIT_LINEPAY_WALLET": "LinePay",
  "ss_payment_GBPRIMEPAY_SHOPEEPAY_WALLET": "ShopeePay Wallet",
  "ss_payment_GBPRIMEPAY_TRUEMONEY_WALLET": "TrueMoney Wallet",
  "ss_payment_GBPRIMEPAY_WECHAT_WALLET": "Wechat Wallet",
  "ss_payment_history": "Sản phẩm đã mua",
  "ss_payment_history_brand_rating": "Brand Ratings",
  "ss_payment_history_digital_product": "Digital product",
  "ss_payment_history_donation": "Donation",
  "ss_payment_history_gift": "Gift",
  "ss_payment_history_tod": "Truth or dare",
  "ss_payment_method": "Phương thức thanh toán",
  "ss_payment_vnpay_qr_description": "Nhớ dùng mã giảm giá VNPAY bạn nhé!",
  "ss_payment_xendit_dana": "Dana Wallet",
  "ss_payment_xendit_gcash": "GCash Wallet",
  "ss_payment_xendit_grabpay": "GrabPay Wallet",
  "ss_payment_xendit_ovo": "Ovo Wallet",
  "ss_payment_xendit_paymaya": "PayMaya Wallet",
  "ss_payment_xendit_shopeepay": "ShopeePay Indo",
  "ss_payment_xendit_virtual_account": "Virtual Account",
  "ss_payment_xendit_virtual_account_bottom": "Bank Transfer",
  "ss_placeholder_profile_email": "Nhập vào email",
  "ss_placeholder_profile_fullname": "Nhập họ tên",
  "ss_placeholder_profile_fullphone": "Nhập số điện thoại",
  "ss_placeholder_profile_username": "Nhập tên đăng nhập",
  "ss_price_max_discount": "Giảm tối đa",
  "ss_product_name": "Tên sản phẩm",
  "ss_profile": "Hồ sơ",
  "ss_profile_account_not_acctive": "Tài khoản chưa xác thực",
  "ss_profile_active_account": "Xác thực ngay",
  "ss_profile_btn_edit": "Chỉnh sửa thông tin",
  "ss_profile_btn_edit_cancel": "Huỷ bỏ",
  "ss_profile_btn_edit_save": "Lưu",
  "ss_profile_change_email_success": "Lưu thông tin thành công",
  "ss_profile_email": "Email",
  "ss_profile_error_email": "Vui lòng nhập đúng định dạng email",
  "ss_profile_error_email_required": "Vui lòng nhập vào email",
  "ss_profile_error_username_existed": "Tên đăng nhập đã tồn tại",
  "ss_profile_error_username_matches": "Chỉ cho phép các ký tự từ a-z và 0-9",
  "ss_profile_error_username_required": "Vui lòng nhập vào tên đăng nhập",
  "ss_profile_fullname": "Họ tên",
  "ss_profile_fullname_error_max_length": "Vui lòng nhập tối đa {{max}} ký tự",
  "ss_profile_fullphone": "Số điện thoại",
  "ss_profile_fullphone_error": "Bạn nhập đúng số điện thoại nhé",
  "ss_profile_helptext_email": "Nếu thay đổi email, bạn sẽ cần xác thực tài khoản",
  "ss_profile_helptext_email_actived": "Email đã được xác thực",
  "ss_profile_username": "Tên đăng nhập",
  "ss_profile_username_error_max_length": "Chỉ cho phép tối đa 255 ký tự",
  "ss_question_dare_for_you": "Thách thức từ bạn",
  "ss_question_truth_for_you": "Câu hỏi từ bạn",
  "ss_recurring_payment_button_submit": "Thanh toán định kỳ",
  "ss_recurring_payment_field_email": "Email",
  "ss_recurring_payment_field_full_name": "Họ và tên",
  "ss_recurring_payment_field_phone": "Số điện thoại",
  "ss_recurring_payment_helper_field_email": "Sản phẩm của bạn sẽ được gửi qua email, bạn nhập chính xác nhé.",
  "ss_recurring_payment_info_title": "Thông tin khách hàng",
  "ss_recurring_payment_month": "tháng",
  "ss_recurring_payment_placeholder_field_email": "Your@example.com",
  "ss_recurring_payment_placeholder_field_full_name": "Tran Van A",
  "ss_recurring_payment_placeholder_field_phone": "09xxxxxxxxxx",
  "ss_referral_button_share": "Giới thiệu bạn bè ngay",
  "ss_referral_campaign": "Giới thiệu bạn bè ngay",
  "ss_referral_copy_link_error": "Sao chép link chia sẻ thất bại",
  "ss_referral_copy_link_success": "Sao chép link chia sẻ thành công",
  "ss_referral_creator_name": "Người sáng tạo",
  "ss_referral_intro_step_1": "Sao chép link giới thiệu sản phẩm",
  "ss_referral_intro_step_1_title": "Bước 1:",
  "ss_referral_intro_step_2": "Chia sẻ cho bạn bè khắp muôn nơi",
  "ss_referral_intro_step_2_title": "Bước 2:",
  "ss_referral_intro_step_3": "Nhận tiền thưởng khi bạn bè mua hàng thành công",
  "ss_referral_intro_step_3_title": "Bước 3:",
  "ss_referral_intro_title_page": "Giới thiệu bạn bè & nhận thưởng",
  "ss_referral_reward_recived": "Phần thưởng nhận được",
  "ss_referral_text_intro_description": "Phần thưởng bạn nhận được là \"Tim\" trên Passio. Bạn sẽ được quy đổi thành thẻ cào để nạp vào điện thoại. Thêm bạn thêm vui lại cùng nhau gom thưởng thỏa thích, ngại gì không mời bạn ơi!",
  "ss_referral_text_title": "Sản phẩm hoàn tim bạn đang chọn",
  "ss_referral_title_page": "Giới thiệu bạn bè",
  "ss_register_link_to_login_page": "Đăng nhập",
  "ss_register_success": "Đăng kí tài khoản thành công",
  "ss_retry": "Thử lại",
  "ss_showing": "Đang hiển thị",
  "ss_store_btn_checkout": "Thanh toán",
  "ss_store_can_not_place_order": "Không thể đặt hàng, vui lòng thử lại sau",
  "ss_store_checkout_email_notification": "👉 Sản phẩm của bạn sẽ được gửi qua email, bạn nhập chính xác nhé.",
  "ss_store_checkout_email_notification_bg": "Sản phẩm của bạn sẽ được gửi qua email, bạn nhập chính xác nhé.",
  "ss_store_checkout_email_title": "Email",
  "ss_store_checkout_error_E1": "Mã giảm giá không tồn tại!",
  "ss_store_checkout_error_E2": "Rất tiếc! Mã giảm giá này đã hết hạn sử dụng",
  "ss_store_checkout_error_E3": "Chưa đến thời gian sử dụng mã. Bạn vui lòng thử lại sau !",
  "ss_store_checkout_error_E4": "Oppp. Mã giảm giá đã hết số lượt sử dụng",
  "ss_store_checkout_error_E5": "Bạn đã mua khóa học này. Vui lòng kiểm tra lịch sử đơn hàng",
  "ss_store_checkout_error_EC": "Sản phẩm không có sẵn",
  "ss_store_checkout_error_EC1": "Sản phẩm đã hết hàng",
  "ss_store_checkout_error_ES": "Không thể đặt hàng, vui lòng thử lại sau",
  "ss_store_checkout_phone_placeholder": "09xxxxxxxx",
  "ss_store_checkout_phone_title": "Số điện thoại",
  "ss_store_checkout_private_message_title": "Đặt lời nhắn ở chế độ riêng tư",
  "ss_store_checkout_user_message_title": "Lời nhắn",
  "ss_store_confirm_leave_order": "Bạn có muốn rời khỏi đây không?",
  "ss_store_copy_successfully": "Sao chép thành công",
  "ss_store_copy_to_other_brower": "Bạn hãy copy đường dẫn này và dán vào safari để tiến hành thanh toán",
  "ss_store_copy_url": "Sao chép đường dẫn",
  "ss_store_create_account": "Tạo tài khoản ?",
  "ss_store_customer_information": "Thông tin khách hàng",
  "ss_store_donation": "Thông tin ủng hộ",
  "ss_store_donation_payment_title": "Chọn phương thức thanh toán",
  "ss_store_email_require": "Bạn nhập Email nhé",
  "ss_store_free": "Miễn phí",
  "ss_store_invalid_email": "Bạn nhập đúng định dạng email nhé",
  "ss_store_invalid_phone": "Bạn nhập đúng Số điện thoại nhé",
  "ss_store_invalid_username": "Chỉ cho phép nhập các ký tự là chữ thường từ a-z và 0-9",
  "ss_store_leave": "Rời khỏi",
  "ss_store_momo_wallet": "MoMo E-Wallet",
  "ss_store_order_detail": "Thanh toán",
  "ss_store_order_item": "Thông tin sản phẩm",
  "ss_store_password_min_length": "Độ dài tối thiểu 6 ký tự",
  "ss_store_password_require": "Vui lòng nhập vào Mật khẩu",
  "ss_store_payment_deeplink": "Đường link thanh toán",
  "ss_store_phone_require": "Bạn nhập đúng Số điện thoại nhé",
  "ss_store_require_payment": "Vui lòng chọn một phương thức để tiến hành thanh toán cho sản phẩm này",
  "ss_store_shopeepay_wallet": "Ví điện tử ShopeePay",
  "ss_store_shoutout_item": "Thông tin Video Shoutout",
  "ss_store_tod_user_message_max_length": "Nội dung vượt quá 500 ký tự.",
  "ss_store_user_message_max_length": "Một số thông tin vượt quá ký tự được phép nhập, bạn kiểm tra lại nhé",
  "ss_store_user_message_passio_placeholder": "Bạn hãy nhắn gì đó với chúng tôi nhé!",
  "ss_store_user_message_placeholder": "Bạn thử nhắn gì đó với người sáng tạo nhé 🤑",
  "ss_store_user_message_tooltip": "Lời nhắn không được hiển thị công khai tại bất kỳ đâu, chỉ riêng bạn và Creator thấy được",
  "ss_store_username_max_length": "Chỉ cho phép tối đa 255 ký tự",
  "ss_store_username_require": "Vui lòng nhập vào Tên đăng nhập",
  "ss_store_virtual_item": "Thông tin phần quà",
  "ss_store_vnpay_atm": "Thẻ ATM",
  "ss_store_vnpay_atm_description": "Hỗ trợ internet banking",
  "ss_store_vnpay_credit_card": "Thẻ Tín dụng / Ghi nợ quốc tế",
  "ss_store_vnpay_qr": "VNPAY-QR / Internet banking",
  "ss_success_name_kol": "thành công",
  "ss_suggest_register_modal_content_text": "Bạn cần đăng nhập hoặc đăng ký để tiếp tục sử dụng dịch vụ của chúng tôi",
  "ss_support_channel": "Kênh hỗ trợ",
  "ss_support_email_info": "info@passio.eco",
  "ss_support_facebook": "Facebook",
  "ss_support_info": "Thông tin hỗ trợ",
  "ss_support_phone_info": "024.77700700",
  "ss_title_tod_dare": "Thông tin Dare",
  "ss_title_tod_truth": "Thông tin Truth",
  "ss_tod_checkout_email_notification": "👉 Thông tin thử thách của bạn sẽ được gửi qua email, bạn nhập chính xác nhé.",
  "ss_tod_checkout_user_message_title": "Nội dung thách thức",
  "ss_tod_dare_btn_checkout": "Thanh toán",
  "ss_tod_dare_code": "Mã Dare",
  "ss_tod_dare_name_kol": "Gửi thách thức đến",
  "ss_tod_email_require": "Bạn nhập Email nhé",
  "ss_tod_invalid_email": "Bạn nhập đúng định dạng email nhé",
  "ss_tod_invalid_phone": "Bạn nhập đúng Số điện thoại nhé",
  "ss_tod_message_require": "Trường này không được để trống",
  "ss_tod_pending_title": "Giao dịch đang được xử lý",
  "ss_tod_phone_require": "Bạn nhập Số điện thoại nhé",
  "ss_tod_truth_btn_checkout": "Gửi",
  "ss_tod_truth_code": "Mã Truth",
  "ss_tod_truth_name_kol": "Gửi câu hỏi đến",
  "ss_tod_user_message_placeholder": "Bạn thử nhắn gì đó với người sáng tạo nhé 🤑",
  "ss_total_price": "Tổng cộng",
  "ss_verify_account_success": "Chúc mừng. Bạn đã xác thực tài khoản thành công",
  "ss_video_shoutout_to": "Gửi yêu cầu tới {{creator_name}}",
  "ss_view_detail": "Xem chi tiết",
  "ss_voucher_has_not_been_used": "Chưa đến thời gian sử dụng mã. Bạn vui lòng thử lại sau !",
  "ss_voucher_not_exist": "Mã giảm giá không tồn tại!",
  "ss_voucher_out_of_use": "Oppp. Mã giảm giá đã hết số lượt sử dụng",
  "ss_watch_content": "Xem nội dung",
  "ss_watch_order_history": "Sản phẩm đã mua",
  "ss_your_voucher_code": "Mã giảm giá của bạn",
  "sure_cancle_password": "Bạn có chắc chắn muốn hủy bỏ các thay đổi ?",
  "system_error": "Lỗi hệ thống",
  "title_checkout": "Passio - Thanh toán",
  "username": "Tên đăng nhập",
  "username_placeholder": "Nhập tên đăng nhập",
  "video_shoutout": "Video Shoutout"
} 
} 
export default vi